import { FormControlLabel, FormControlLabelProps } from '@mui/material';
import React from 'react';

const FormControlLabelWrapper: React.FC<FormControlLabelProps> = ({ ...props }) => (
 
  <FormControlLabel {...props} />
);

export default FormControlLabelWrapper;